//Archivo dedicado al menu de todos los imports de TemisCivil
//Imports relacionados de TemisCivil
//-----------Principal-----------
import Plantilla from '@/components/TemisCivil/Comun/Plantilla.vue';

//-----------Oficialía de partes-----------
import Reportes from '@/components/TemisCivil/OficialiaDePartes/Reportes.vue';
import Recepcion from '@/components/TemisCivil/OficialiaDePartes/RecepcionTC.vue';
import ReportesEnvios from '@/components/TemisCivil/OficialiaDePartes/ReportesEnvios.vue';

//Se crea la lista de paths
const TemisCivil = [
  {
    path: '/TemisCivil/', component: Plantilla, meta: { RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 20 }, children: [
      { path: '/TemisCivil/Recepcion', component: Recepcion, meta: { RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 20, ModuloId: 1, EsRequeridoValidacionDeInstitucion: true } },
      { path: '/TemisCivil/Reportes', component: Reportes, meta: { RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 20, ModuloId: 2, EsRequeridoValidacionDeInstitucion: true } }
    ]
  }
];

//Se regresa la lista de paths
export default TemisCivil;



// WEBPACK FOOTER //
// ./src/router/TemisCivil.js